import React from 'react'
import SemaPageSections from '../../components/Sema'

const allComponents = {
  ...SemaPageSections,
}

const ComponentRenderer = ({
  sectionKey,
  sectionConfig,
  pageName = 'programs',
}) => {
  const componentName = sectionConfig?.componentName
  const Component = allComponents[componentName]

  // If component doesn't exist, show error message
  if (!Component) {
    return (
      <div
        key={sectionKey}
        className="mx-4 my-2 rounded-lg border-l-4 border-red-500 bg-red-50 p-4"
      >
        <p className="mb-1 text-sm font-bold text-red-700">
          ⚠️ Component "{componentName}" not found
        </p>

        <p className="mb-2 text-xs text-red-700/80">
          Section: {sectionConfig?.sectionName}
        </p>

        <p className="text-[11px] italic text-red-700">
          Available components: {Object.keys(allComponents).join(', ')}
        </p>
      </div>
    )
  }

  // If section is not visible, render nothing
  if (!sectionConfig?.isVisible) {
    return <React.Fragment key={`${pageName}_${sectionKey}`} />
  }

  // Dynamically rendered component
  return (
    <Component
      key={`${pageName}_${sectionKey}`}
      data={{ ...sectionConfig?.data }}
      sectionKey={`${pageName}_${sectionKey}`}
    />
  )
}

export default ComponentRenderer
